export default __webpack_public_path__ + "static/media/element_51.c201f5b3.avif";